import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
const API_ROOT_URL = environment.ApiRoot + '/config';
@Injectable()
export class SysConfigService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/Sys_Config_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	getById(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/Sys_Config_Detail?code=${itemId}`, { headers: httpHeaders });
	}
	update(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/Sys_Config_Update', item, { headers: httpHeaders });
	}
	getListGroup(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/Sys_Config_Group_List`, { headers: httpHeaders });
	}
	getListQuyTrinhByLoai(loai): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/approvalprocess/GetListQuyTrinhByLoai?loai=${loai}`, { headers: httpHeaders });
	}

	setDNXKAutoGenerateTime(configTime: any) : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.patch<any>(API_ROOT_URL + '/dnxkautogenerationtime', configTime, { headers: httpHeaders });
	}

	getDNXKAutoGenerateTime() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + '/dnxkautogenerationtime', { headers: httpHeaders });
	}

	getUserConfig(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + '/User_Configs', { headers: httpHeaders });
	}
	updateUserConfig(userConfig: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/User_Configs_Update', userConfig, { headers: httpHeaders });
	}
}
